module.exports = __webpack_public_path__ + "img/banner-kynorelle.e18ddeff.webp";